import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useTranslation } from 'react-i18next';

import styles from './index.module.sass';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

const AlertConfirm = (props) => {
  const { t } = useTranslation('documents');
  const [alertOpen, setAlertOpen] = useState(false);

  const {
    openConfirm = alertOpen,
    setOpenConfirm = setAlertOpen,
    title = '',
    text = '',
    callback,
    setLoading,
  } = props;

  const handleClose = () => {
    setOpenConfirm(false);
    setLoading(false);
  };

  return (
    <Dialog
      open={openConfirm}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby='alert-dialog-slide-title'
      aria-describedby='alert-dialog-slide-description'>
      <DialogTitle id='alert-dialog-slide-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-slide-description'>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='primary' className={styles.buttonCancel}>
          {t('button1')}
        </Button>
        <Button
          className={styles.buttonAcept}
          onClick={() => {
            if (callback) callback();
          }}
          color='primary'
          autoFocus>
          {t('button2')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertConfirm;
